import { lazy } from 'react';
import { LazyDependency } from './LazyDependency.tsx';
import type { SortableRowsProps } from './SortableRows.tsx';

// lazy() cannot carry the generic through, so the cast is confined to this one line
const SortableRowsImpl = lazy(() =>
  import('./SortableRows.tsx').then(m => ({ default: m.SortableRows as React.FC<SortableRowsProps<unknown>> }))
);

/**
 * Loads @dnd-kit on demand. The boundary sits here rather than around the surrounding editors so the
 * editors stay eager and keep receiving value/onChange from their AntForm.Item.
 *
 * An empty list needs no sorting at all, so it renders nothing and does not fetch the chunk.
 */
export const LazySortableRows = <T,>(props: SortableRowsProps<T>) => {
  if (!props.items.length) {
    return null;
  }

  return (
    <LazyDependency height="32px">
      <SortableRowsImpl {...(props as SortableRowsProps<unknown>)} />
    </LazyDependency>
  );
};
